export enum DesignerMessageType {
  highLightHoveredItemMessage = 13,
  renderFrameMessage = 30,
  createElementFromActionMessage = 31,
  replaceElementFromActionMessage = 32,
  setSelectedTabItemMessage = 33,
  setSelectedStepItemMessage = 34,
  setSelectedCollapseItemMessage = 35,
  remoteUserSelectionsMessage = 36,
  scrollIntoViewMessage = 37
}
